export default function OverlayLoading() {
  return (
    <div className="w-full h-screen fixed top-0 left-0 bg-black opacity-50 z-50 justify-center items-center flex">
      <div className="loader-white" />
    </div>
  );
}
